import queryString from 'query-string';
import chroma from 'chroma-js';

import { PaletteHydrationState, StyleByIdMap } from '../';
import { Layout } from '@graphql/types';
import { DemoFontOptionKey, LocationPalette } from '../types';
import produce from 'immer';
import { ACCEPTED_LAYOUT_VALUES, BASE_FONT_KEYS, DEFAULT_PALETTE } from '../constants';
import merge from 'lodash-es/merge';
import { makeDebugger } from '@lib';
const debug = makeDebugger('hydrateFromState.ts');

export const INITIAL_SECTIONS_STATE: PaletteHydrationState['sections'] = {
  themes: {
    open: false,
    category: null,
    showCategoryBuckets: false,
    useSuggestedBackgroundColor: true,
    themeKey: 'midnight_peony'
  },
  layout: { open: false, layout: Layout.aloha },
  colors: { open: false, color: '#dfce85ff' },
  fonts: { open: false, font: 'default' as DemoFontOptionKey },
  advanced: { open: false }
};

export const INITIAL_STATE: PaletteHydrationState = {
  palette: DEFAULT_PALETTE,
  error: null,
  sections: {
    ...INITIAL_SECTIONS_STATE
  }
};

export const hydrateStateFromSearch = (hasLoaded = false, styleByIdMap?: StyleByIdMap) =>
  produce<PaletteHydrationState>(draft => {
    const values = queryString.parse(window.location.search);
    if (values.template && ACCEPTED_LAYOUT_VALUES.has(values.template as Layout)) {
      draft.sections.layout.layout = values.template as Layout;
    }

    if (values.theme && styleByIdMap) {
      const searchTheme = values.theme as string;
      const style = styleByIdMap[searchTheme];
      if (style) {
        draft.sections.themes.themeKey = searchTheme;
      }
    }

    if (values.font && BASE_FONT_KEYS.includes(values.font as DemoFontOptionKey)) {
      draft.sections.fonts.font = values.font as DemoFontOptionKey;
    }

    if (values.palette) {
      let palette: LocationPalette;
      try {
        palette = merge(draft.palette, JSON.parse(values.palette as string));
        draft.palette = palette;
        const baseColor = palette.baseColor || DEFAULT_PALETTE.baseColor;
        draft.sections.colors.color = chroma([...baseColor.slice(0, 3).map(x => x * 255), baseColor[3]]).hex();
      } catch (e) {
        draft.sections.colors.color = chroma(DEFAULT_PALETTE.baseColor).css();
        debug('Palette from URL is invalid.');
      }
    }
  });
